/** @jsx jsx */
import React from 'react';
import styled from '@emotion/styled';
import { jsx, css } from '@emotion/core';
import { useStoreActions, useStoreState } from 'easy-peasy';

import { Button } from '~/styles/index.styles';

const PresetsWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.breakpoints.md.up} {
    display: block;
  }
`;

const PresetTitle = styled.h4`
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: 16px;
  margin: 0 0 8px;
`;

const PresetsBody = styled.div`
  display: flex;
`;

const presetButton = css`
  margin: 0 10px 0 0;
  padding: 10px 20px;
`;

const PresetMap = styled.img`
  margin: 0 auto;
  margin-bottom: 10px;
  width: 100%;
  height: auto;
  max-width: 100px;
  display: block;
`;

const PresetLabel = styled.span`
  padding: 0 5px;
`;

const Presets = () => {
  const setResultFromPreset = useStoreActions(
    (actions) => actions.app.setResultFromPreset
  );

  const isDrawingEnabled = useStoreState((state) => state.app.isDrawingEnabled);

  if (!isDrawingEnabled) {
    return null;
  }

  return (
    <PresetsWrapper>
      <PresetTitle>Oder wählen Sie aus folgenden Vorschlägen:</PresetTitle>
      <PresetsBody>
        <Button
          css={presetButton}
          onClick={() => setResultFromPreset('eastwest')}
        >
          <PresetMap src="images/staticMaps/east-west.png" alt="" />
          <PresetLabel>Ost-West</PresetLabel>
        </Button>
        <Button
          css={presetButton}
          onClick={() => setResultFromPreset('bavaria')}
        >
          <PresetMap src="images/staticMaps/bayern-vs-rest.png" alt="" />
          <PresetLabel>Bayern</PresetLabel>
        </Button>
        <Button
          css={presetButton}
          onClick={() => setResultFromPreset('northsouth')}
        >
          <PresetMap src="images/staticMaps/north-south.png" alt="" />
          <PresetLabel>Nord-Süd</PresetLabel>
        </Button>
      </PresetsBody>
    </PresetsWrapper>
  );
};

export default Presets;
